/**
 * @file BinLevelScanBar.tsx
 * @description Поле «Скан ячейки, полки или стеллажа» на странице «Ячейки»
 *   (phase19.22, W14-9; ui-design §8): скан ячейки открывает её шторку, скан
 *   полки или стеллажа — «Что лежит на уровне» (`LevelContentsSheet`).
 *
 * Сам резолв — `useBinScan`: тот же разбор, что у поля ячейки в документах,
 * чтобы «A-02» везде значило одно и то же.
 */

import { LevelContentsSheet } from "./LevelContentsSheet";
import { useBinScan } from "./useBinScan";
import { ScanField } from "../../ui/ScanField";

interface Props {
  warehouseId: string;
  /** Открыть шторку ячейки по id (страница знает справочник). */
  onOpenBin: (binId: string) => void;
}

export function BinLevelScanBar({ warehouseId, onOpenBin }: Props) {
  // Ячейка (и единственная ячейка уровня) — сразу её шторка; уровень — шторка уровня.
  const scan = useBinScan(warehouseId, (bin) => onOpenBin(bin.id));

  return (
    <div className="flex flex-col gap-1">
      <ScanField
        mode="scanAndSearch"
        autoFocus={false}
        busy={scan.busy}
        disabled={!warehouseId}
        placeholder="Скан ячейки, полки или стеллажа"
        showFeedbackIndicator={false}
        helperText="Покажет, что лежит на месте: ячейка, полка (A-02) или стеллаж (A)"
        onQueryChange={() => scan.clearError()}
        onSubmit={(raw) => void scan.resolve(raw)}
      />
      {scan.error ? <p className="text-xs text-warning">{scan.error}</p> : null}
      {scan.level ? (
        <LevelContentsSheet
          level={scan.level}
          onOpenBin={(binId) => {
            scan.closeLevel();
            onOpenBin(binId);
          }}
          onOpenShelf={scan.openShelf}
          onClose={scan.closeLevel}
        />
      ) : null}
    </div>
  );
}
